import {
  ArrowLeftCircle,
  InfoEmpty,
  Page,
  WarningTriangle,
} from 'iconoir-react'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { EmptyText, RichText } from '../../components/common/CellText'
import Message from '../../components/common/Message'
import FileItem from '../../components/FileItemComponent/FileItem'
import CheckLight from '../../components/image/CheckLight'
import CheckSuccessIcon from '../../components/image/CheckSuccessIcon'
import SkeletonWorkDetail from '../../components/Skeleton/SkeletonWorkDetail'
import { getExtensionFile } from '../../utils/common'
import { DATE_FORMAT_SLASH, TASK_DOCUMENT_TYPE } from '../../utils/constants'

import MainButton from '../../components/button/MainButton'
import { Divider, useTheme } from '@mui/material'
import LinkedWork from '../../components/Linked/LinkedWork'
import InforDialog from './InforDialog'
import MissionUpdate from './MissionUpdate'

const MissionDetail = ({ taskStore }) => {
  const { getTaskListDetailByTaskCode, taskDetail } = taskStore
  const { taskId } = useParams()
  const navigate = useNavigate()

  const [message, setMessage] = useState({ title: '', isOpen: false })

  const [loading, setLoading] = useState(false)
  const [openInfo, setOpenInfor] = useState(false)
  const [openUpdate, setOpenUpdate] = useState(false)
  const descriptionElementRef = useRef(null)
  const theme = useTheme()
  const getDetailTask = async () => {
    try {
      setLoading(true)
      await getTaskListDetailByTaskCode(taskId)
    } catch (err) {
      setMessage({ title: err.vi, isOpen: true })
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    ;(async () => {
      await Promise.all([getDetailTask()])
    })()
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId])

  const handleClickOpenInfo = e => {
    e.stopPropagation()
    setOpenInfor(true)
    document.body.style.overflow = 'hidden'
  }
  const handleOpenUpdate = () => {
    setOpenUpdate(true)
  }

  const handleCloseInfo = () => {
    setOpenInfor(false)
    document.body.style.overflow = 'auto'
  }

  useEffect(() => {
    if (openInfo) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openInfo])
  return (
    <>
      <div
        className="flex items-center p-[20px] gap-[22px]"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <ArrowLeftCircle
          className="flex-shrink-0"
          onClick={() => {
            navigate(-1)
          }}
        />
        <span className="font-bold text-[28px] leading-[29px]">Nhiệm vụ</span>
      </div>
      <div className={`px-5 py-[20px] mb-16`}>
        {loading ? (
          <SkeletonWorkDetail />
        ) : (
          <>
            <div className="mb-2 small-text">Thời gian:</div>
            <div className="normal-text">
              Ngày giao:{' '}
              {moment(taskDetail?.ngay_bat_dau).format(DATE_FORMAT_SLASH)} -
              Hoàn thành:{' '}
              {taskDetail?.ngay_ket_thuc ? (
                moment(taskDetail?.ngay_ket_thuc).format(DATE_FORMAT_SLASH)
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <div className="mb-2 small-text mt-[14px]">Trạng thái:</div>
            <div className="flex gap-7">
              {taskDetail?.ket_qua?.phan_tram_hoan_thanh === '100' ? (
                <div className="normal-text flex items-center gap-[6px]">
                  <CheckSuccessIcon />
                  <span>Hoàn thành</span>
                </div>
              ) : (
                <div className="normal-text flex items-center gap-[6px]">
                  <CheckLight />
                  <span>Chưa hoàn thành</span>
                </div>
              )}
              {taskDetail?.ket_qua?.phan_tram_hoan_thanh !== '100' &&
                taskDetail?.ngay_ket_thuc &&
                moment(new Date()).isAfter(taskDetail?.ngay_ket_thuc) && (
                  <div className="normal-text flex items-center gap-[6px]">
                    <WarningTriangle
                      color="#DB8300"
                      fill="#FFE5A1"
                      width={20}
                      height={20}
                    />
                    <span>Quá hạn</span>
                  </div>
                )}
            </div>
            <div className="mb-2 small-text mt-[14px]">Nội dung:</div>
            <div className="normal-text">
              {taskDetail?.ghi_chu ? (
                <RichText text={taskDetail?.noi_dung} />
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <div className="mb-2 small-text mt-[14px]">Ghi chú:</div>
            <div className="normal-text">
              {taskDetail?.ghi_chu ? (
                <RichText text={taskDetail?.ghi_chu} />
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <div className="mb-2 small-text mt-[14px]">Văn bản:</div>
            <div className="normal-text">
              {taskDetail?.van_bans?.length > 0 ? (
                <>
                  {taskDetail.van_bans
                    .filter(
                      doc => doc.loai_van_ban === TASK_DOCUMENT_TYPE.INCOMING
                    )
                    .map(el => (
                      <div
                        className="text-[#005796] underline leading-6 flex"
                        onClick={() =>
                          navigate(
                            `/internal-document/incoming-document/view/${el.code_van_ban}`
                          )
                        }>
                        <Page
                          className="flex-shrink-0"
                          style={{
                            color: '#005796',
                            marginRight: 4,
                            marginTop: 2,
                          }}
                          width="16px"
                          height="19px"
                        />
                        {`${el.document_number} - ${el.ten_van_ban}`}
                      </div>
                    ))}
                  {taskDetail.van_bans
                    .filter(
                      doc => doc.loai_van_ban === TASK_DOCUMENT_TYPE.OUTGOING
                    )
                    .map(el => (
                      <div
                        className="text-[#898400] underline leading-6 flex"
                        onClick={() =>
                          navigate(
                            `/internal-document/outgoing-document/view/${el.code_van_ban}`
                          )
                        }>
                        <Page
                          className="flex-shrink-0"
                          style={{
                            color: '#898400',
                            marginRight: 4,
                            marginTop: 2,
                          }}
                          width="16px"
                          height="19px"
                        />
                        {`${el.document_number} - ${el.ten_van_ban}`}
                      </div>
                    ))}
                </>
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <div className="mb-2 small-text mt-[14px]">
              Tài liệu đính kèm văn bản:
            </div>
            <div className="normal-text">
              {taskDetail?.file_dinh_kem_vb?.length > 0 ? (
                taskDetail?.file_dinh_kem_vb
                  .map(file => ({
                    id: file.file_id,
                    name: file.file_title,
                  }))
                  .map(file => (
                    <FileItem
                      file={file}
                      key={file.id}
                      file_id={file.id}
                      file_name={file.name}
                      file_type={getExtensionFile(file.name)}
                    />
                  ))
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <div className="mb-2 small-text mt-[14px]">
              Danh sách công việc:
            </div>
            <div className="normal-text">
              {taskDetail?.linkedWork?.length > 0 ? (
                <LinkedWork linkedWorkList={taskDetail.linkedWork} />
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <Divider className="mt-4" />
            <div className="mb-2 small-text mt-[14px]">Nội dung kết quả:</div>
            <div className="normal-text">
              {taskDetail?.ket_qua?.noi_dung_ket_qua_giao ? (
                <RichText text={taskDetail?.ket_qua?.noi_dung_ket_qua_giao} />
              ) : (
                <EmptyText>Không có</EmptyText>
              )}
            </div>
            <div className="mb-2 small-text mt-[14px]">Kiến nghị:</div>
            <div className="normal-text">
              {taskDetail?.ket_qua?.kien_nghi ? (
                <RichText text={taskDetail?.ket_qua?.kien_nghi} />
              ) : (
                <EmptyText>Chưa có</EmptyText>
              )}
            </div>
          </>
        )}
      </div>
      <footer
        style={{
          position: 'fixed',
          bottom: 0,
          backgroundColor: 'white',
        }}
        className="flex items-center justify-between gap-5 px-5 w-full py-4 shadow-[0px_0px_8px_rgba(0,0,0,0.25)] ">
        <div
          className=" flex w-[128px] justify-center gap-x-2 items-center  bg-[rgba(0,115,199,0.07);] py-[10px] w- text-primary px-[14px] rounded-full text-sm leading-5 cursor-pointer font-medium flex-shrink-0"
          onClick={handleClickOpenInfo}>
          <div>
            <InfoEmpty />
          </div>
          <span>Thông tin</span>
        </div>
        <MainButton onClick={handleOpenUpdate}>Cập nhật nhiệm vụ</MainButton>
      </footer>
      <InforDialog
        isOpen={openInfo}
        handleCloseInfo={handleCloseInfo}
        descriptionElementRef={descriptionElementRef}
        taskDetail={taskDetail}
      />
      <MissionUpdate
        open={openUpdate}
        handleClose={() => setOpenUpdate(false)}
        taskDetail={taskDetail}
        getDetailTask={getDetailTask}
      />
      <Message
        message={message.title}
        openMessage={message.isOpen}
        severity={message.severity}
        closeMessage={() => {
          setMessage({ title: '', isOpen: false })
        }}
      />
    </>
  )
}

export default memo(inject('taskStore')(observer(MissionDetail)))
